/**
 * Bannière rouge affichée en haut d'une modale d'édition quand un autre
 * utilisateur est en train de modifier la ressource.
 *
 * L'utilisateur peut consulter le contenu mais ne peut pas sauvegarder.
 */
import { Lock } from 'lucide-react';

export function LockBanner({ userName, expiresAt, onClose }) {
    let minutesRemaining = null;
    if (expiresAt) {
        const diff = new Date(expiresAt).getTime() - Date.now();
        if (diff > 0) minutesRemaining = Math.ceil(diff / 60000);
    }
    return (
        <div
            className="flex items-center gap-3 px-4 py-2.5 bg-red-600 text-white text-sm font-medium shadow-sm"
            data-testid="lock-banner"
            role="alert"
        >
            <Lock size={18} className="shrink-0" />
            <div className="flex-1">
                <strong>{userName || 'Un autre utilisateur'}</strong> est en train de modifier cette fiche — vous pouvez uniquement la consulter.
                {minutesRemaining != null && (
                    <span className="ml-2 text-red-100 text-xs">
                        (verrou auto-expiré dans ~{minutesRemaining} min)
                    </span>
                )}
            </div>
            {onClose && (
                <button
                    type="button"
                    onClick={onClose}
                    className="shrink-0 text-white/90 hover:text-white bg-white/10 hover:bg-white/20 rounded px-3 py-1 text-xs font-semibold"
                    data-testid="lock-banner-close-btn"
                >
                    Fermer
                </button>
            )}
        </div>
    );
}
